import styled from "styled-components";

const KycStyleWrapper = styled.div`
  padding-top: 56px;
  padding-bottom: 140px;
  background: #090a1a;
`;

export default KycStyleWrapper;
